<!--供应商半年排名表（工艺大类）——供方考核排名-->
<template>
  <ls-table-layout>
    <div class="table-page-search-wrapper" slot="search">
      <ls-search-form @search="onSearch" @reset="resetQuery" :formList="formList" ref="refSearchForm">
        <global-select
          ref="versionRef"
          slot="version"
          :allowClear="false"
          :default-active-first-option="true"
          v-decorator="['version', { rules: [{ required: true }] }]"
          :value.sync="queryParams.version"
          selectType="selectSearch"
          requestApi="/scp/supplierRankCategory/findVersionComboBox"
          :selectItem="{ value: 'realValue', label: 'label' }"
          :setParams="{}"
          searchParam="version"
          @init-success-call-back="initSuccessCallBack"
        />
        <global-select
          ref="productBroadCategoryRef"
          slot="productBroadCategory"
          :value.sync="queryParams.productBroadCategory"
          selectType="selectSearch"
          requestApi="/scp/supplierRankCategory/findCategoryComboBox"
          :selectItem="{ value: 'realValue', label: 'label' }"
          :setParams="{}"
          searchParam="category"
        />
        <global-select
          ref="supplierNameRef"
          slot="supplierName"
          :value.sync="queryParams.supplierName"
          selectType="selectSearch"
          requestApi="/scp/supplierRankCategory/findSupplierComboBox"
          :selectItem="{ value: 'label', label: 'label' }"
          :setParams="{}"
          searchParam="supplierName"
        />
      </ls-search-form>
    </div>
    <div slot="btn">
      <a-space>
        <a-button type="primary" :loading="loading" @click="handleRankCal">排名计算</a-button>
        <download-modal :apiFun="downloadRequest" ref="download" />
        <a-button type="primary" :loading="loading" @click="handleExport">导出</a-button>
        <a-button type="primary" :loading="loading" @click="handleImport">导入</a-button>
        <import-excel ref="importExcelRef" :downloadParams="downloadParams" :uploadParams="upload" @refresh="afterUploadSearch" />
        <a-button type="primary" :loading="loading" @click="handleDetailExport">价格明细导出</a-button>
      </a-space>
    </div>
    <template v-slot:table>
      <div class="page-header-content">
        <!-- 表格 -->
        <ls-api-table
          class="pre-order-demand-table"
          ref="dataTable"
          :columns="columns"
          :tableProps="tableProps"
          rowKey="id"
          :scroll="{ fixScreen: true, x: 1400 }">
          <template slot="dateFormat" slot-scope="data">
            {{ data.text && $moment(data.text).format('YYYY-MM-DD HH:mm:ss') }}
          </template>
        </ls-api-table>
      </div>
    </template>
  </ls-table-layout>
</template>

<script>
import { generateLsTableResData } from '@/utils/util.js'
import DownloadModal from '@/views/components/download-modal/download-modal.vue'
import cloneDeep from 'lodash.clonedeep'
import moment from 'moment'
import {
  apiScpSupplierRankCategoryFindPage,
  apiSupplierRankCategoryExport,
  apiScpCategoryRankingCalculation,
  apiRankCategoryExportPriceDetail
} from '@/api/finished-goods-order'
import ImportExcel from "@/views/finished-goods-order/base-data/supplier-process-ranking/components/importExcel"

export default {
  name: 'SupplierProcessRanking',
  components: { DownloadModal, ImportExcel },
  data() {
    return {
      loading: false,
      downloadRequest: apiSupplierRankCategoryExport, // 导出请求
      apiSupplierRankCategoryExport,
      apiRankCategoryExportPriceDetail,
      // 表格配置
      tableProps: {
        requestApi: generateLsTableResData(apiScpSupplierRankCategoryFindPage, false),
        pageCurrent: true
      },
      // 用户导入参数
      upload: {
        url: process.env.VUE_APP_API_BASE_URL + '/scp/supplierRankCategory/import' // 上传的地址
      },
      // 导入模板下载参数
      downloadParams: {
        method: 'post',
        url: 'scp/supplierRankCategory/template',
        name: `供方考核排名导入模板_${moment().format('YYYY-MM-DD')}.xlsx`
      },
      // 查询参数
      queryParams: {
        version: undefined,
        productBroadCategory: undefined,
        supplierName: undefined
      },
      // 表格数据
      tableList: [],
      formList: [
        { label: '版本', decorator: ['version'], type: 'version' },
        { label: '工艺大类', decorator: ['productBroadCategory'], type: 'productBroadCategory' },
        { label: '供应商名称', decorator: ['supplierName'], type: 'supplierName' }
      ],
      columns: [
        { title: '版本号', dataIndex: 'version', align: 'center', width: 110 },
        { title: '工艺大类', dataIndex: 'productBroadCategoryName', align: 'center', width: 90 },
        { title: '供应商编码', dataIndex: 'supplierCode', align: 'center', width: 90 },
        { title: '供应商名称', dataIndex: 'supplierName', align: 'center', width: 120 },
        { title: '售后不良率(%)', dataIndex: 'afterSalesDefectRate', align: 'center', width: 100 },
        { title: '售后排名', dataIndex: 'afterSalesRank', align: 'center', width: 80 },
        { title: '售后得分', dataIndex: 'afterSalesScore', align: 'center', width: 80 },
        { title: '价格(万元)', dataIndex: 'price', align: 'center', width: 90 },
        { title: '价格排名', dataIndex: 'priceRank', align: 'center', width: 80 },
        { title: '价格得分', dataIndex: 'priceScore', align: 'center', width: 80 },
        { title: '总得分', dataIndex: 'totalPriceScore', align: 'center', width: 80 },
        { title: '总排名', dataIndex: 'totalRank', align: 'center', width: 80 },
        { title: '分配比例(%)', dataIndex: 'allocationRatio', align: 'center', width: 100 },
        { title: '创建人', dataIndex: 'createName', align: 'center', width: 80 },
        { title: '创建时间', dataIndex: 'createTime', align: 'center', width: 140 }
      ]
    }
  },
  created() {},
  mounted() {
    this.loading = false;
    // this.onSearch()
  },
  methods: {
    // 初始化只调一次查询成功回调
    initSuccessCallBack() {
      this.onSearch()
    },
    // 导入弹窗
    handleImport() {
      this.$refs.importExcelRef.show()
    },
    // 二次查询
    afterUploadSearch(isUpload) {
      // 存在上传成功后，重新查询版本下拉
      if (isUpload) {
        this.onSearch({ ...this.$refs.refSearchForm.getSearchValue() })
        this.$refs.versionRef.handleSearch(''); // 重新查询版本下拉
      }
    },
    // 二次查询
    reSearch() {
      this.onSearch({ ...this.$refs.refSearchForm.getSearchValue() })
    },
    // 表单搜索
    onSearch(value = {}) {
      const params = Object.assign({}, this.queryParams, value)
      delete params.searchFormLabel
      if (!params.version) {
        this.$message.warning('请先选择版本')
        return
      }
      this.$refs.dataTable.searchParams = cloneDeep(params)
      this.$refs.dataTable.getData()
    },
    // 重置按钮操作
    resetQuery() {
      this.queryParams = {
        version: undefined,
        productBroadCategory: undefined,
        supplierName: undefined
      }
      this.$refs.dataTable.searchParams = this.queryParams
      this.$refs.refSearchForm.form.setFieldsValue(this.queryParams)
      this.$refs.versionRef.handleSearch(''); // 重新查询版本下拉
      this.$refs.productBroadCategoryRef.handleSearch(''); // 重新查询工艺大类下拉
      this.$refs.supplierNameRef.handleSearch(''); // 重新查询供应商名称下拉
    },
    // 排名计算
    handleRankCal() {
      this.loading = true;
      apiScpCategoryRankingCalculation({}).then(res => {
        if (res?.code === 200) {
          this.$message.success('操作成功')
          this.$refs.versionRef.handleSearch(''); // 重新查询版本下拉
          this.reSearch()
        }
      }).finally(() => {
        this.loading = false;
      })
    },
    // 价格明细导出
    handleDetailExport() {
      if (!this.queryParams.version) {
        this.$message.warning('请先选择版本')
        return
      }
      this.downloadRequest = this.apiRankCategoryExportPriceDetail
      this.$nextTick(() => {
        const params = this.$refs.dataTable.searchParams
        this.$refs.download.openModal(params)
      })
    },
    // 导出
    handleExport() {
      if (!this.queryParams.version) {
        this.$message.warning('请先选择版本')
        return
      }
      this.downloadRequest = this.apiSupplierRankCategoryExport
      this.$nextTick(() => {
        const params = this.$refs.dataTable.searchParams
        this.$refs.download.openModal(params)
      })
    }
  }
}
</script>

<style scoped lang="less"></style>
